<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" @click.self="closeDeleteModel">
      <div class="modal" role="dialog" aria-modal="true" aria-labelledby="modalTitle">
        <header class="modal-header">
          <slot name="header">
            <h2 id="modalTitle">Supprimer</h2>
          </slot>
          <button type="button" class="btn-close" @click="closeDeleteModel">×</button>
        </header>

        <section class="modal-body">
          <slot name="body">
            {{ messageDelete }}
          </slot>
        </section>

        <footer class="modal-footer">
          <button type="button" class="btn-green" @click="validerDeleteModel">Oui</button>
          <button type="button" class="btn-red" @click="closeDeleteModel">Non</button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "DeleteModal",
  props: {
    messageDelete: {
      type: String,
      default: "Êtes-vous sûr de vouloir supprimer ?"
    }
  },
  methods: {
    closeDeleteModel() {
      this.$emit("closeDeleteModel");
    },
    validerDeleteModel() {
      this.$emit("validerDeleteModel");
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal {
  background: #ffffff;
  min-width: 400px;
  max-width: 600px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: fadeIn 0.3s ease-in-out;
}

.modal-header,
.modal-footer {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-header {
  background-color: #f4f4f4;
  color: #333;
  font-size: 22px;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
  position: relative;
}

.modal-body {
  padding: 20px;
  font-size: 16px;
  color: #555;
}

.btn-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  transition: color 0.3s;
}

.btn-close:hover {
  color: #333;
}

.modal-footer .btn-green,
.modal-footer .btn-red {
  margin: 0 5px;
  width: 120px;
  padding: 12px;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-green {
  background-color: #4caf50;
  color: #fff;
}

.btn-green:hover {
  background-color: #45a049;
}

.btn-red {
  background-color: #f44336;
  color: #fff;
}

.btn-red:hover {
  background-color: #d32f2f;
}

/* Animation d'apparition */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
